import React, { useEffect, useState } from 'react';
import MDButton from 'components/MDButton';
import MDModal from 'components/MDModal';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDInput from 'components/MDInput';
import { useAppServices } from 'hook/services';
import Editor from 'components/editor';

const EditPromptModal = ({ data, handleRefresh }) => {
  const AppService = useAppServices();

  const [open, setOpen] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [name, setName] = useState(data.name || '');
  const [instructions, setInstructions] = useState(data.instructions || '');

  const handleModal = () => setOpen(true);
  const closeModal = () => setOpen(false);

  const extractVariables = (text) => {
    const regex = /{{([^}]+)}}|{@([^}]+)}|{\(([^)]+)\)}/g;
    const matches = new Set();
    let match;
    while ((match = regex.exec(text)) !== null) {
      const variable = match[1] || match[2] || match[3];
      if (variable) matches.add(variable.trim());
    }
    return Array.from(matches);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setProcessing(true);

    const dynamic_variables = extractVariables(instructions);

    const payload = {
      id: data._id,
      name,
      instructions,
      dynamic_variables,
    };

    const { response } = await AppService.ai_prompt_templates.update({ payload });

    if (response?.success) {
      closeModal();
      handleRefresh();
    }

    setProcessing(false);
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 612,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  };

  return (
    <>
      <MDButton color="info" variant="contained" onClick={handleModal}>
        Edit
      </MDButton>

      <MDModal open={open} onClose={closeModal}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              Edit Prompt Template
            </MDTypography>

            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput
                label="Name"
                name="name"
                fullWidth
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Instructions</MDTypography>
              <Editor handleChange={setInstructions} data={instructions} />
            </MDBox>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeModal}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Save
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  );
};

export default EditPromptModal;
